window.cselect = {

  init: () => {
    window.cselect.addListeners();
  },

  addListeners: () => {
    let cselects = document.querySelectorAll('.cselect:not(.event_is_set)');
    if (cselects.length) {
      cselects.forEach((item) => {
        let selected = item.querySelector('.cselect__selected'),
            single_options = item.querySelectorAll('.cselect__option');
        selected.addEventListener('click', (item) => {
          window.cselect.toggleOptions(item.currentTarget.closest('.cselect'));
        });
        single_options.forEach((single_option) => {
          single_option.addEventListener('click', () => {
            let index = parseFloat(single_option.getAttribute('data-index')),
                next_element = item.nextElementSibling,
                selected_text = item.querySelector('.cselect__selected__text .value');

            if (next_element && next_element.classList.contains('select')) {
              let select = next_element.querySelector('select'),
                  event = new Event('change', { bubbles: true }),
                  data_submit_on_change = item.getAttribute('data-submit-on-change');

              select.selectedIndex = index;
              select.dispatchEvent(event);

              window.cselect.hideAllOptions();

              if (data_submit_on_change == 'true') {
                item.closest('form').submit();
              }
            }

            selected_text.innerHTML = single_option.innerHTML;

            single_options.forEach((item) => {
              item.classList.remove('is_selected');
            });
            single_option.classList.add('is_selected');

            cselects.forEach(div => {
              div.classList.remove('is_active');
            });

            if (single_option.getAttribute('data-url')) {
              window.location = single_option.getAttribute('data-url');
            }
          });
        })
        item.classList.add('event_is_set');
      });

      document.addEventListener('click', function(event) {
        let inside = false;
        cselects.forEach(div => {
          if (div.contains(event.target)) {
            inside = true;
          }
        });
        if (!inside) {
          cselects.forEach(div => {
            div.classList.remove('is_active');
          });
        }
      });
    }
  },

  toggleOptions: (item) => {
    if (item.classList.contains('is_active')) {
      window.cselect.hideOptions(item);
    } else {
      window.cselect.showOptions(item);
    }
  },

  showOptions: (item) => {
    item.classList.add('is_active');
  },

  hideOptions: (item) => {
    item.classList.remove('is_active');
  },

  hideAllOptions: () => {
    let cselects = document.querySelectorAll('.cselect');
    if (cselects.length) {
      cselects.forEach((item) => {
        item.classList.remove('is_active');
      });
    }
  }

};

window.cselect.init();
